import React from 'react';
import { CobuText, CobuStack, CobuImage, CobuButton } from '@cobu/ui';
import { IconSymbol } from '../ui/IconSymbol';
import { URLS } from '../../constants';
import { analyticsService, AnalyticsEvent } from '@cobu/analytics';

interface ProfileImageSectionProps {
    currentImage: string | null;
    user: {
        firstName?: string;
        lastName?: string;
    };
    onShowImagePicker: () => void;
}

export default function ProfileImageSection({
    currentImage,
    user,
    onShowImagePicker
}: ProfileImageSectionProps) {
    const handleProfileImagePress = () => {
        /* ANALYTICS_DISABLED: PRESS_EDIT_PROFILE_PICTURE ('press_edit_profile_picture')
        analyticsService.trackEvent(AnalyticsEvent.PRESS_EDIT_PROFILE_PICTURE);
        */
        onShowImagePicker();
    }
    return (
        <CobuStack
            ai="center"
            gap="$3"
            bg="$background"
            p="$4"
            mb="$2"
            br="$2"
            w="100%"
        >
            <CobuButton
                onPress={handleProfileImagePress}
                w="100%"
                ai="center"
                bg="$background"
                bw={0}
                pressStyle={{ opacity: 0.8 }}
            >
                <CobuStack
                    w={80}
                    h={80}
                    ai="center"
                    jc="center"
                    br="$full"
                    pos="relative"
                    mt="$4"
                >
                    {currentImage && currentImage !== URLS.DEFAULT_PROFILE_IMAGE ? (
                        <CobuStack
                            w="100%"
                            h="100%"
                            ai="center"
                            jc="center"
                            bg="$backgroundSecondary"
                        >
                            <CobuImage
                                src={currentImage}
                                width={80}
                                height={80}
                                borderRadius={40}
                            />
                        </CobuStack>
                    ) : (
                        <CobuStack
                            w="100%"
                            h="100%"
                            ai="center"
                            jc="center"
                            bg="$backgroundSecondary"
                        >
                            <CobuText
                                variant="heading"
                                color="$colorSecondary"
                                fontSize={33}
                                fontWeight="bold"
                            >
                                {user.firstName?.[0]}{user.lastName?.[0]}
                            </CobuText>
                        </CobuStack>
                    )}

                    {/* Camera Icon Overlay */}
                    <CobuStack
                        pos="absolute"
                        b={-8}
                        r={-8}
                        w={32}
                        h={32}
                        ai="center"
                        jc="center"
                        bg="$backgroundSecondary"
                        br="$full"
                        btw={2}
                        btc="$white"
                    >
                        <IconSymbol size={16} name="camera" color="$cobuDarkBlue" />
                    </CobuStack>
                </CobuStack>
            </CobuButton>

            {/* Add text to indicate it's clickable */}
            <CobuText
                variant="caption"
                color="$cobuDarkBlue50"
                fontSize={12}
                fontWeight="regular"
                mt="$5"
            >
                Tap to change photo
            </CobuText>
        </CobuStack>
    );
} 